import { takeEvery, call, put, fork } from 'redux-saga/effects';
import * as actions from '../ducks/activity';
// import { getNotifById } from '../ducks/analytics';
import * as api from '../services/api';
// import { toast } from 'react-toastify';
import toast from '../components/Toastify';

// getUserActivity
function* getUserActivity() {
  try {
    const res = yield call(api.GET, '/activity/getUserActivity');
    if (res.status == 'success') {
      yield put(actions.getUserActivitySuccess(res.data));
    }
    else {
      toast.error('Error in get user activity');
    }
  } catch (error) {
    yield put(actions.errorGetUserActivity(true));
  }
}

//updUserClick
function* updUserClick(action) {
  try {
    const res = yield call(api.POST, '/activity/updUserClick', action.data);
    if (res.status == 'success') {
      yield put(actions.getUserActivitySuccess(res.data));
    }
    else {
      toast.error('Error in update activity notification');
    }
  } catch (error) {
    yield put(actions.errorupdUserClick(true));
  }
}

//updUserView
function* updUserView() {
  try {
    const res = yield call(api.GET, '/activity/updUserView');
    if (res.status == 'success') {
      yield put(actions.getUserActivitySuccess(res.data));
    }
    else {
      toast.error('Error in update activity notification');
    }
  } catch (error) {
    yield put(actions.errorGetUserActivity(true));
  }
}

export function* watch() {
  yield takeEvery(actions.UPD_USER_VIEW, updUserView);
  yield takeEvery(actions.UPD_USER_CLICK, updUserClick);
  yield takeEvery(actions.GET_USER_ACTIVITY, getUserActivity);
}

export default function* rootSaga() {
  yield [
    fork(watch)
  ];
}


// WEBPACK FOOTER //
// ./src/sagas/activity.js